export class Home {
  arte: Arte;
  categoria: string;
  metricas: Metrica[];
  metricasEndPoint: string;
  nombre: string;
  opcionesRequeridas: string[];
  manuales: {
    art: string;
    returnUrl: string;
  };
}

class Arte {
  descripcion: string;
  imagenUrl: string;
  titulo: string;
  descripcionCorta?: string;
}

export class Metrica {
  activo: boolean;
  id: string;
  imagenUrl: string;
  titulo: string;
  ultimosDIas: number;
  valor: number;
}
